jQuery( document ).ready( function() {
	jQuery( '.ajax-location-hide' ).each( function() {
		jQuery( this ).children( '.ajax-location-child-hide' ).slice( 5 ).css( 'display', 'none' );
	} );
	function handleButtonClick() {
		const postsCounter = 0;
		const remaingPosts = 0;
		const clickCount = 0;
		let clickedCategory;
		//  	 jQuery( '.js-buttons__filter' ).click( function( event ) {
		// 		    jQuery( '.loader-container' ).show();
		// 		    jQuery( '.caregivers.outer-box' ).each( function() {
		// 		// Check if the current element's computed display is not 'none'
		// 		if ( jQuery( this ).css( 'display' ) !== 'none' ) {
		// 			// Add a class to the current element
		// 			jQuery( this ).parent().addClass( 'has-border' );
		// 			console.log( "Element with class 'caregivers outer-box' has display set to something other than 'none' and now has the class 'has-border'" );
		// 		} else {
		// 			console.log( "Element with class 'caregivers outer-box' has display set to 'none'" );
		// 		}
		// 	} );
		// 	setTimeout( function() {
		// 		jQuery( '.loader-container' ).hide();
		// 	}, 500 );
		// } );

		jQuery( '.ajax-location-load-more' ).click( function( event ) {
			event.preventDefault();
			// if ( jQuery( this ).attr( 'clicked-category' ) !== clickedCategory ) {
			// 	clickCount = 0;
			// 	postsCounter = 0;
			// }

			// clickCount++;

			// const foundPosts = parseInt( jQuery( this ).attr( 'found-posts' ) );
			// clickedCategory = jQuery( this ).attr( 'clicked-category' );
			// if ( foundPosts > 4 ) {
			// 	console.log( clickCount );
			// 	if ( clickCount == 1 ) {
			// 		remaingPosts = foundPosts;
			// 		jQuery( '.' + clickedCategory ).slice( 0, 9 ).show();
			// 		jQuery( '.' + clickedCategory ).slice( 0, 9 ).parent().addClass( 'has-border' );

			// 		postsCounter = postsCounter + 8;
			// 		remaingPosts = remaingPosts - 8;
			// 	} else {
			// 		remaingPosts = remaingPosts - 4;
			// 		postsCounter = postsCounter + 4;
			// 		jQuery( '.' + clickedCategory ).slice( 9, postsCounter ).show();
			// 		jQuery( '.' + clickedCategory ).slice( 9, postsCounter ).parent().addClass( 'has-border' );
			// 	}
			// }
			// jQuery( this ).find( '.button-number' ).text( remaingPosts );
			// if ( postsCounter >= foundPosts ) {
			// 	jQuery( this ).parent().hide();
			// }
			// console.log( postsCounter );
			// console.log( 'Remaing Posts: ' + remaingPosts );
			// console.log( 'Clicked Category: ' + clickedCategory );

			clickedCategory = jQuery( this ).attr( 'clicked-category' );
			jQuery( '.' + clickedCategory ).parent().addClass( 'has-border' );
			jQuery( '.' + clickedCategory ).show();
			jQuery( this ).parent().hide();
		} );
	}
	handleButtonClick();
} );
